import React, { Component, Fragment } from 'react';
import { observer, inject } from 'mobx-react';
import { withRouter } from "react-router";
import { notification, Table, Button, Input, Pagination, Checkbox, Select } from 'antd';

@inject(({ orderStore }) => ({ 
  userList: orderStore.userList,
  pageInfo: orderStore.pageInfo,
  orderUserList: orderStore.orderUserList,
  userListLoding: orderStore.userListLoding,
  selUserInfo: orderStore.selUserInfo,

  onChangValueUserInfo: orderStore.onChangValueUserInfo,
  valCondition: orderStore.valCondition,
  onChangValue: orderStore.onChangValue,
  disCartList: orderStore.disCartList,

  centerOption: orderStore.centerOption,
}))
@observer
class UserList extends Component {
  state = {
    inputUserNm: '',
  };

  UNSAFE_componentWillMount() {
    if (this.props.ceType !== process.env.REACT_APP_TYPE_BRANCH) {
      this.props.orderUserList();
    }
  }
  
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.userList !== this.props.userList) {
      if (nextProps.userList.length > 0) {
        nextProps.userList.map((item,idx)=>{return (
          (item.userId === this.props.selUserInfo.userId) &&
          (this.props.onSelect(item))
        )});
      }
    }
  }

  onPageChange = (pageIdx) => {
    // console.log('page:', page);
    this.props.orderUserList(pageIdx);
  };

  onSearch = () => {
    if (this.state.inputUserNm.length > 0 && this.state.inputUserNm.length < 2) {
      notification.warning({placement: 'bottomLeft', message: `검색어를 2자이상 입력해주세요.`, duration: 2});
      return false;
    }
    this.props.orderUserList(1, null, this.state.inputUserNm);
    this.props.onChangValueUserInfo("userId", '');
    this.props.onChangValueUserInfo("jobCd", '');
    this.props.onChangValueUserInfo("userSex", '');
    this.props.onSelect(null);
  };

  onPressEnter = (e) => {
    if (e.key === 'Enter') {
      this.onSearch();
    }
  };

  render() {
    const { 
      userList, 
      pageInfo, 
      userListLoding, 
      selUserInfo, 
      onChangValueUserInfo,
      ceType,
      orderUserList,
      valCondition,
      onChangValue,
      disCartList,

      centerOption,
    } = this.props;
    const { inputUserNm } = this.state;
    const columns = [
      { title: '사번', dataIndex: 'userId', width: '20%', align: 'center' },
      { title: '사원명', dataIndex: 'userNm', width: '15%', align: 'center' },
      { title: '직무', dataIndex: 'jobNm', width: '25%', align: 'center' },
      { title: '성별', dataIndex: 'userSex', width: '13%', align: 'center',
        render: (item, record) => { return(
          item === 'M' ? <Fragment>남</Fragment> : <Fragment>여</Fragment>
        )}
      },
      { title: '센터', dataIndex: 'ceNm', width: '27%', align: 'center' },
    ];
    return (
      <Fragment>
        {(ceType !== process.env.REACT_APP_TYPE_BRANCH)
        ? <h2>▶ 임직원 현황</h2>
        : <div className="search-box mo_srch_box">
            <div className="search-content" style={{float:'left'}}>
              <span className="labal2"><h3>▶ &nbsp;&nbsp;센터 &nbsp;&nbsp;: &nbsp;&nbsp;</h3></span>
              <Select
                size={'large'}
                style={{ width: 300, marginRight: '20px' }}
                value={valCondition.selectCeCd}
                onChange={(value, option)=>{
                  onChangValue('selectType', option.option);
                  onChangValue('selectCeCd', value);
                  onChangValue('userNm', '');
                  onChangValue('pageIdx', 1);
                  onChangValue('exceptionYn', 'N');

                  this.setState({inputUserNm: ''});
                  onChangValueUserInfo("userId", '');
                  onChangValueUserInfo("jobCd", '');
                  onChangValueUserInfo("userSex", '');
                  this.props.onSelect(null);

                  this.props.orderUserList();
                }}
              >
                <Select.Option key={""} option={""}>센터를 선택해주세요.</Select.Option>
                {centerOption.map(item=>{ return (
                  <Select.Option key={item.ceCd} option={item.ceType}>{item.ceNm}</Select.Option>
                )})}
              </Select>
            </div>
          </div>
        }
        {(ceType === process.env.REACT_APP_TYPE_BRANCH && valCondition.selectCeCd === '') 
        ? <Fragment></Fragment>
        : <Fragment>
        <div className="button-group">
          <div className="srch_rbox">
            <b style={{ verticalAlign: '-3px', fontWeight: 'inherit' }}>사원명</b>
            <Input.Search 
              placeholder="사원명을 입력하세요"
              value={inputUserNm}
              onChange={(e)=>this.setState({inputUserNm: e.target.value})}
              onPressEnter={this.onPressEnter}
              onSearch={this.onSearch}
              style={{ width: 200 }}
            />
          </div>
          <div className="button-right">
            <ul>
              <li>
                <Button
                  size={"small"}
                  onClick={()=>{
                    // 11111111 개별사업자 00000000 단기간근로자
                    onChangValueUserInfo("userId", '11111111');
                    onChangValueUserInfo("jobCd", '개별사업자');
                    onChangValueUserInfo("userSex", '');
                    this.props.onSelect({
                      userId: '11111111',
                      userNm: '개별사업자'
                    });
                  }}
                >예외인력</Button>
              </li>
            </ul>
          </div>
        </div>

        <Table
          loading={userListLoding}
          rowKey={(record)=>record.userId}
          rowClassName={(record)=>
            (record.userId === selUserInfo.userId) 
            ? (valCondition.exceptionYn === 'Y' ? "blue" : ((record.orderYn === 'N') ? "blue gray" : "blue"))
            : (valCondition.exceptionYn === 'Y' ? "" : (record.orderYn === 'N') ? "gray" : "")
          }
          columns={(ceType === process.env.REACT_APP_TYPE_YUJIN || ceType === process.env.REACT_APP_TYPE_MASTER) 
            ? columns : columns.slice(0, columns.length-1)} 
          dataSource={userList} 
          scroll={{ y: 400 }}
          pagination={false}
          onRow={(record, rowIndex) => {
            return {
              onClick: e => {
                e.preventDefault();
                onChangValueUserInfo("userId", record.userId);
                onChangValueUserInfo("jobCd", record.jobCd);
                onChangValueUserInfo("userSex", record.userSex);
                
                this.props.onSelect(record);
              },
            };
          }}
        />
        <br />
        <div className="page_nav_ct">
          <Pagination
            showSizeChanger={false}
            current={pageInfo !== null ? pageInfo.pageIndex : 1}
            total={pageInfo !== null ? pageInfo.totalCnt : 0}
            pageSize={pageInfo !== null ? pageInfo.recordCountPerPage : 0}
            onChange={this.onPageChange}
          />
        </div>

        <div className="button-group">
          <div className="button-right">
            <ul>
              <li>
                <Checkbox
                  checked={valCondition.exceptionYn === "Y" ? true : false}
                  onChange={(e)=>{
                    this.setState({ inputUserNm: '' });
                    onChangValueUserInfo("userId", '');
                    onChangValueUserInfo("jobCd", '');
                    onChangValueUserInfo("userSex", '');
                    this.props.onSelect(null);

                    onChangValue('exceptionYn', e.target.checked === true ? "Y" : "N");
                    orderUserList();
                    disCartList();
                  }}
                >기준외주문</Checkbox>
              </li>
            </ul>
          </div>
        </div>
        </Fragment>
      }
      </Fragment>

    );
  }

}

export default withRouter(UserList);
